export default $ => {
  $('.eFormBuilderField--Product_special .js-product_variant_id input').change(function (e)
  {
      let div = $(this).closest('.eFormBuilderField--Product_special').find('.important-section');
      if (div.length > 0)
      {
        let val = $(this).is(':checked');
        if (val) div.show();
        else div.hide();
      }
  });
  $('.eFormBuilderField--Product_special select.js-product_variant_id').change(function (e)
  {
    let div = $(this).closest('.eFormBuilderField--Product_special').find('.important-section');
    if (div.length > 0)
    {
      let val = $(this).val() > 0;
      if (val) div.show();
      else div.hide();
    }
  });
};



// WEBPACK FOOTER //
// ./assets/js/component/insurance.js